import { render, staticRenderFns } from "./ver_detail.vue?vue&type=template&id=5db8a5c2&scoped=true&"
import script from "./ver_detail.vue?vue&type=script&lang=js&"
export * from "./ver_detail.vue?vue&type=script&lang=js&"
import style0 from "./ver_detail.vue?vue&type=style&index=0&id=5db8a5c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db8a5c2",
  null
  
)

export default component.exports